import { makeStyles, makeResetStyles, shorthands } from '@fluentui/react-components';

export const useBaseTargetFolderPickerStyles = makeResetStyles({
  marginLeft: '0px',
  marginRight: '0px',
});

export const useTargetFolderPickerStyle = makeStyles({
  targetFolderPickerViewContainer: {
    '& .target-folder-picker-asset-cell': {
      opacity: 0.5,
    },
  },
  dialog: {
    '&.fui-DialogSurface': {
      ...shorthands.overflow('hidden'),
      maxWidth: '890px',
    },
    '& .fui-DialogContent': {
      maxHeight: '500px',
      minHeight: '500px',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    '& .fui-DialogActions': {
      marginTop: '16px',
    },
  },
  filterContainer: {
    ...shorthands.padding('8px', '0'),
  },
  folderPathContainer: {
    marginLeft: '-4px',
    marginBottom: '-8px',
  },
});
